import { MouseEventHandler } from "react";
import { Button, Icon, Box } from "@bca/ui-library";
import css from "@styled-system/css";
import styled from "styled-components";

import media from "../media";

const StyledBox = styled(Box)`
  display: none;
  ${media.desktop} {
    display: block;
  }
`;

const TrackButtonDesktop: React.FunctionComponent<{
  isTracked: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
}> = ({ isTracked, onClick }) => {
  return (
    <StyledBox data-testid="desktop-track-container">
      <Button
        variant="tertiary"
        padding="10px"
        height="auto"
        width="auto"
        onClick={onClick}
        css={`
          ${css({
            borderColor: isTracked ? "secondary-orange" : "primary-white",
          })}
        `}
        title={isTracked ? "Remove Tracking" : "Track"}
      >
        <Icon
          width="21px"
          height="21px"
          name="star"
          weight={isTracked ? "solid" : "regular"}
          color={isTracked ? "secondary-orange" : "footer-blue"}
        ></Icon>
      </Button>
    </StyledBox>
  );
};

export default TrackButtonDesktop;
